<template>
  <div class="search-page" v-show="show">
    <!-- 头部相关 -->
    <div class="header" id="search-header">
      <div class="i-logo"></div>
      <div class="search-box">
        <div class="search-input">
          <input type="text" placeholder="输入关键词搜索游戏" v-model="keywords" id="onInput" />
          <!-- @focus="onFocus()" -->
          <van-icon name="search" class="i-search" color="#6A6B6E" />
        </div>
      </div>
      <div class="i-login" @click="onCancelSearch">取消</div>
    </div>
    <!-- 热门搜索 -->
    <div class="hot-search">
      <p class="search-title">热门搜索</p>
      <div class="hot-game-box">
        <span
          v-for="(item,index) in hotGameList"
          :key="index"
          @click="gameDateil('gamedetails',{gameid: item.gid})"
        >{{item.game_name}}</span>
      </div>
    </div>
    <!-- 搜索结果 -->
    <div class="search-result-box" v-show="searchListShow" id="searchList">
      <p class="result-title" v-show="false">搜索结果</p>
      <div class="game-result-box">
        <p class="game-name" v-for="(item,index) in searchList" :key="index" v-show="searchList">
          <van-icon name="search" class="i-search" color="#6A6B6E" />
          <span @click="gameDateil('gamedetails',{gameid: item.gid})">{{item.game_name}}</span>
        </p>
        <p class="game-name" v-show="searchList==''">
          <span>暂无该游戏</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import comTools from "@assets/js/until";
import { contTools } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
export default {
  name: "searchPage",
  mixins: [contTools],
  props: {
    value: {
      default: true,
      type: Boolean
    }
  },
  components: {},
  data() {
    return {
      show: false,
      searchListShow: false, // 搜索结果列表显示隐藏
      keywords: "", // 关键字
      searchList: "", // 搜索结果列表
      hotGameList: "" // 热门搜索
    };
  },
  watch: {
    // 父子组件传来的值
    value(val) {
      this.autoFocus();
      this.getHeaderH();
      this.show = !val;
    },
    // 给父组件传递改变后的值
    show(val) {
      this.$emit("input", !val);
    },
    // 关键词搜索
    keywords(val) {
      if (val) {
        this.debouncedSearch();
      } else {
        this.searchListShow = false;
      }
    }
  },
  computed: {},
  created() {
    this.debouncedSearch = comTools.setDebounce(this.onSearch, 500);
  },
  mounted() {},
  methods: {
    // 获取输入框高度
    getHeaderH() {
      this.$nextTick(() => {
        let headerH = document.querySelector("#search-header");
        let searchList = document.querySelector("#searchList");
        let hotSearchH = document.querySelector(".hot-search");
        searchList.style.top = headerH.offsetHeight + "px";
        hotSearchH.style.paddingTop = headerH.offsetHeight + "px";
        // console.log(headerH.offsetHeight);
      });
    },
    // 关键词搜索
    onSearch() {
      this.searchListShow = true;
      let data = comTools.assignObj(this.wapConfig(), {
        game_name: this.keywords
      });
      data.sign = comTools.querySort(data);
      wapApiFun.search(data).then(res => {
        if (res.code == 200) {
          this.searchList = res.data.search_games;
        }
      });
    },
    // 输入框聚焦事件
    onFocus() {
      if (this.keywords) {
        // console.log("输入框聚焦事件");
        this.searchListShow = true;
      } else {
        this.searchListShow = false;
      }
    },
    // 自动聚焦
    autoFocus() {
      this.$nextTick(() => {
        //正确写法
        let inputelement = document.getElementById("onInput");
        inputelement.focus();
        let data = comTools.assignObj(this.wapConfig(), {
          game_name: this.keywords
        });
        data.sign = comTools.querySort(data);
        wapApiFun.search(data).then(res => {
          if (res.code == 200) {
            this.hotGameList = res.data.hot_games;
          }
        });
      });
    },
    // 取消搜索
    onCancelSearch() {
      console.log("取消搜索");
      this.show = false;
      this.searchListShow = false;
      this.keywords = "";
      // let flag = true;
      // this.$bus.emit("showHome", flag);
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.search-page {
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  background-color: #fff;
  z-index: 99;
  // 头部相关
  .header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    .jc-content();
    z-index: 98;
    background-color: #fff;
    min-height: 1.6rem /* 120/75 */;
    // border-bottom: 1px solid #eaeaea;
    .i-logo {
      width: 2rem /* 150/75 */;
      height: 0.733333rem /* 55/75 */;
      background: url("~@/assets/image/home/i-logo.png") no-repeat center;
      background-size: contain;
    }
    .search-box {
      width: 65%;
      margin-right: 0.333333rem /* 25/75 */;
      // border: 1px solid #000;

      .search-input {
        position: relative;
        padding: 0.266667rem /* 20/75 */ 0;
        input {
          width: 100%;
          background-color: #eaeaea;
          border-radius: 0.933333rem /* 70/75 */;
          padding: 0.2rem /* 15/75 */ 0;
          padding-left: 15px;
          box-sizing: border-box;
          display: inline-block;
          line-height: 20px;
        }
        .i-search {
          position: absolute;
          right: 0.4rem /* 30/75 */;
          top: 50%;
          transform: translate(0, -50%);
        }
        ::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: #333333;
          font-size: 13px;
        }
      }
    }
    .i-login {
      width: 1rem /* 60/75 */;
      height: 0.733333rem /* 55/75 */;
      line-height: 0.733333rem /* 55/75 */;
      font-size: 0.466667rem /* 35/75 */;
      // background: url("../../assets/image/home/i-zhanghao.png") no-repeat center;
      // background-size: contain;
    }
  }
  // 热门搜索
  .hot-search {
    width: 100%;
    .search-title {
      font-size: 0.4rem /* 30/75 */;
      color: #333;
      padding: 0.2rem 0.5rem;
    }
    .hot-game-box {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-left: 0.5rem;
      span {
        padding: 0.133333rem /* 10/75 */ 0.266667rem /* 20/75 */;
        font-size: 0.4rem /* 30/75 */;
        // background-color: #eaeaea;
        border-radius: 0.4rem /* 30/75 */;
        text-align: center;
        margin-right: 0.333333rem /* 25/75 */;
        margin-top: 0.133333rem /* 10/75 */;
        margin-bottom: 0.333333rem /* 25/75 */;
      }
    }
  }
  // 搜索结果
  .search-result-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    min-height: 50vh;
    background-color: #fff;
    // padding-left: 0.5rem;
    .result-title {
      font-size: 0.4rem /* 30/75 */;
      color: #333;
      padding: 0.2rem /* 15/75 */ 0;
    }
    .game-result-box {
      .game-name {
        .jc-content(auto);
        padding: 0.3rem 0.5rem;
        > span {
          padding-left: 0.4rem;
        }
        &:last-child {
          position: relative;
          // &::after {
          //   width: 100%;
          //   text-align: center;
          //   content: "到底了---";
          //   line-height: 1rem;
          //   position: absolute;
          //   left: 0;
          //   top: 2rem;
          //   .font-color();
          // }
        }
      }
    }
  }
}
</style>